import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import "./index.css";
import { AuthProvider } from "./AuthContext";
import { ComingSoonProvider } from "./components/coming-soon-modal";

function Main() {
  return (
    <React.StrictMode>
      <AuthProvider>
        <ComingSoonProvider>
          <App />
        </ComingSoonProvider>
      </AuthProvider>
    </React.StrictMode>
  );
}

const root = createRoot(document.getElementById("root") as HTMLElement);
root.render(<Main />);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
